import { render, staticRenderFns } from "./study-statistic.vue?vue&type=template&id=08163aeb&scoped=true"
import script from "./study-statistic.vue?vue&type=script&lang=js"
export * from "./study-statistic.vue?vue&type=script&lang=js"
import style0 from "./study-statistic.vue?vue&type=style&index=0&id=08163aeb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08163aeb",
  null
  
)

export default component.exports